import React, { useState } from 'react'
import { InputsPopup } from '../Input/InputsPopup';

export const Textarea = ({changeHandler, tabIndex, disabled=false, className = '', value=''}) => {
  const minSizes = {
    minWidth: '100%',
    minHeight: '200%',
  }
  const sizes = {
    width: '400px',
    height: '110px'
  }
  return (
    <InputsPopup className='cell' placeholder={value || '(пусто)'} minSizes={minSizes} sizes={sizes} noPadding={true} >
      <textarea tabIndex={tabIndex} disabled={disabled} className='textarea-input dark-theme-bg0' value={value} onChange={changeHandler}>
      </textarea>
    </InputsPopup>
  );
}

